import React, { useState } from "react";
import HeaderBar from "../../../Components/UI/headerbar";
import DataTable from "../../../Components/UI/table/DataTable";
import StatusBadge from "../../../Components/UI/statusBadge";
import TableActions from "../../../Components/UI/table/TableActions";
import { useQuery } from "react-query";
import { getLoyaltySettings, deleteLoyaltySetting, updateLoyaltySetting } from "../../../MyApi/loyalty";
import LoyaltyModal from "./loyaltyModal";
import { formatPrice } from "../../../utils/formatPrice";
import i18next from "i18next";

const LoyaltySettings = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState(null);

  const { data, isLoading, refetch, isFetching, error } = useQuery(
    ["getLoyaltySettings", currentPage],
    () => getLoyaltySettings(currentPage)
  );

  const loyaltySettings = data?.data?.LoyaltySettings || [];

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setModalMode("add");
    setModalId(null);
  };

  const handleAddClick = () => {
    setModalMode("add");
    setModalId(null);
    setIsModalOpen(true);
  };

  const handleEditClick = (id) => {
    setModalMode("edit");
    setModalId(id);
    setIsModalOpen(true);
  };

  const handleViewClick = (id) => {
    setModalMode("show");
    setModalId(id);
    setIsModalOpen(true);
  };

  const loyaltyColumns = [
    {
      label: "معدل الكسب",
      accessor: "earn_rate",
      render: (row) => `${row.earn_rate}%`
    },
    {
      label: "الحد الأدنى للطلب",
      accessor: "min_order_for_earn",
      render: (row) => `${formatPrice( row.country.currency_factor, row.min_order_for_earn )} ${row.country?.currency_symbol || ''}`
    },
    {
      label: "نقاط الإحالة",
      accessor: "referral_points"
    },
    {
      label: "نقاط التقييم",
      accessor: "rating_points"
    },
    {
      label: "الدولة",
      render: (row) => (
        <div className="d-flex align-items-center gap-2">
          <span>{row.country?.name}</span>
          <span className="text-muted">({row.country?.code})</span>
        </div>
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={() => handleViewClick(row.id)}
          edit={() => handleEditClick(row.id)}
          deleteFn={() => deleteLoyaltySetting(row.id)}
          mutationKey={["deleteLoyaltySetting"]}
          refetch={refetch}
          isLoading={isLoading}
          id={row.id}
          
          viewPermission={"view_loyalty_setting"}
          editPermission={"update_loyalty_setting"}
          deletePermission={"delete_loyalty_setting"}
        
        />
      ),
    },
  ];

  return (
    <div>
      <LoyaltyModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        refetch={refetch}
        modalMode={modalMode}
        modalId={modalId}
      />
      <HeaderBar
        title={"إعدادات نظام الولاء"}
        content={"إدارة إعدادات نظام الولاء والمكافآت"}
      />
      <DataTable
        title={"إعدادات الولاء"}
        data={loyaltySettings}
        columns={loyaltyColumns}
        actionLabel={"إضافة إعداد ولاء جديد "}
        onAddClick={handleAddClick}
        isLoading={isLoading}
        isFetching={isFetching}
        createPermission={"create_loyalty_setting"}
        error={error}
        onRetry={() => refetch()}
      />
    </div>
  );
};

export default LoyaltySettings;
